/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
	 // appVersion: require('../../package.json').version + '-qa',
	 // appVersion: require('../../package.json').version + '-dev',
	//  appVersion: require('../../package.json').version + '-uat',
	  appVersion: require('../../package.json').version + '-beta',
	// appVersion: require('../../package.json').version,


	production: false,
	// order: 'https://jfl-api.roadcast.co.in/api/v1/order/',
	// auth: 'https://jfl-api.roadcast.co.in/api/v1/auth/',
	// event: 'https://jfl-api.roadcast.co.in/api/v1/event/',
	// report: 'https://jfl-api.roadcast.co.in/api/v1/reporting/',
	// yard: 'https://jfl-api.roadcast.co.in/api/v1/yard/',
	// route: 'https://jfl-api.roadcast.co.in/api/v1/route/',
	// integrations: 'https://jfl-api.roadcast.co.in/api/v1/integration/',
	// order: 'https://jfl-api-qa.roadcast.co.in/api/v1/order/',
	// auth: 'https://jfl-api-qa.roadcast.co.in/api/v1/auth/',
	// event: 'https://jfl-api-qa.roadcast.co.in/api/v1/event/',
	// report: 'https://jfl-api-qa.roadcast.co.in/api/v1/reporting/',
	// yard: 'https://jfl-api-qa.roadcast.co.in/api/v1/yard/',
	// route: 'https://jfl-api-qa.roadcast.co.in/api/v1/route/',
	// integrations: 'https://jfl-api-qa.roadcast.co.in/api/v1/integration/',
	// order: 'https://jfl-api-dev.roadcast.co.in/api/v1/order/',
	// auth: 'https://jfl-api-dev.roadcast.co.in/api/v1/auth/',
	// event: 'https://jfl-api-dev.roadcast.co.in/api/v1/event/',
	// report: 'https://jfl-api-dev.roadcast.co.in/api/v1/reporting/',
	// yard: 'https://jfl-api-dev.roadcast.co.in/api/v1/yard/',
	// route: 'https://jfl-api-dev.roadcast.co.in/api/v1/route/',
	// integrations: 'https://jfl-api-dev.roadcast.co.in/api/v1/integration/',
	// order: 'https://jfl-api-uat.roadcast.co.in/api/v1/order/',
	// auth: 'https://jfl-api-uat.roadcast.co.in/api/v1/auth/',
	// event: 'https://jfl-api-uat.roadcast.co.in/api/v1/event/',
	// report: 'https://jfl-api-uat.roadcast.co.in/api/v1/reporting/',
	// yard: 'https://jfl-api-uat.roadcast.co.in/api/v1/yard/',
	// route: 'https://jfl-api-uat.roadcast.co.in/api/v1/route/',
	// integrations: 'https://jfl-api-uat.roadcast.co.in/api/v1/integration/',
	order: 'https://jfl-api-beta.roadcast.co.in/api/v1/order/',
	auth: 'https://jfl-api-beta.roadcast.co.in/api/v1/auth/',
	event: 'https://jfl-api-beta.roadcast.co.in/api/v1/event/',
	report: 'https://jfl-api-beta.roadcast.co.in/api/v1/reporting/',
	yard: 'https://jfl-api-beta.roadcast.co.in/api/v1/yard/',
	route: 'https://jfl-api-beta.roadcast.co.in/api/v1/route/',
	integrations: 'https://jfl-api-beta.roadcast.co.in/api/v1/integration/',

	track: 'https://api-trackpy.roadcast.co.in/api/v1/auth/',
	bolt: 'https://apibolt.roadcast.co.in/api/v1/auth/',
    hereApiKey: '3Xz_d2T_zyHKm1WhBNRAdtmToAQ_HhLmWtMstKeFo34',
	geocode: 'https://api-track.roadcast.co.in/reverse',
	firebaseConfig: {
		apiKey: 'AIzaSyCTks4mDMdTsdtZ2duLTfBCLvFvz7_J_NA',
		authDomain: 'synco-dc96f.firebaseapp.com',
		databaseURL: 'https://synco-dc96f.firebaseio.com',
		projectId: 'synco-dc96f',
		storageBucket: 'synco-dc96f.appspot.com',
		messagingSenderId: '396410044695',
		appId: '1:396410044695:web:b349e9b39770b377',
	},
	agora: {
		appId: 'e090104b4b274b61b807a9ee2de741a2',
	},
};
